import { render, staticRenderFns } from "./chart-table.vue?vue&type=template&id=23ec7b96&scoped=true&"
import script from "./chart-table.vue?vue&type=script&lang=js&"
export * from "./chart-table.vue?vue&type=script&lang=js&"
import style0 from "./chart-table.vue?vue&type=style&index=0&id=23ec7b96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ec7b96",
  null
  
)

export default component.exports